<template>
  <a class="floor-video-item-components" v-if="video" target="_blank" :href="video.url">
    <div class="video-image">
      <img :src="video.filedPath" alt="" class="image">
    </div>
    <div class="video-title">{{video.name}}</div>
    <div class="video-content clearfix">
      <div class="school" v-if="false">长沙市长郡中学</div>
      <div class="course cloud-course" :class="[`cloud-course-${blueBG}`]" v-if="video.subjectName">
        {{video.subjectName}}
      </div>
      <div class="num">
        <img src="../../assets/images/cloud/num-people.png" alt="" class="icon">
        <span class="text">{{video.visitTimes || 0}}</span>
      </div>
    </div>
  </a>
</template>

<script>
import { queryMore } from '@/assets/js/api/cloud'

export default {
  name: 'FloorVideoItem',
  props: {
    video: {
      type: Object,
      default () {
        return null
      },
    },
    blueBG: {
      type: String,
      default: '',
    },
  },
  methods: {
    routerPageurl () {
      if (this.video) {
        const params = { playUrl: this.video.url }
        queryMore(params).then(res => {
          if (res) {
            const href = res.userName
            window.open(href, '_blank')
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.floor-video-item-components {
  display: block;
  width: 100%;
  cursor: pointer;

  .video-image {
    width: 224px;
    height: 126px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;

    .image {
      width: 100%;
      height: 100%;
    }
  }

  .video-title {
    margin-top: 13px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    font-size: 16px;
    color: $--color-text-primary;
  }

  .video-content {
    margin-top: 7px;
    width: 100%;

    .school {
      float: left;
      display: inline-block;
      vertical-align: middle;
      margin-right: 9px;
      max-width: 156px;
      font-size: 12px;
      color: $--color-text-gray;
    }

    .course {
      float: left;
    }

    .num {
      float: right;
      display: inline-block;
      vertical-align: middle;
      font-size: 0;

      .icon {
        margin-right: 4px;
        width: 9px;
        height: 10px;
      }

      .text {
        font-size: 12px;
        color: $--color-text-gray;
      }
    }
  }
}
</style>
